import { RequiredBehaviors } from 'app/beta-editor/pages/types';

const createTemplateBehavior: RequiredBehaviors = {
  label: () => '',
  menuLabel: () => '',
  crumbLabel: () => 'Create Template',
  data: () => {},
  status: () => 'success',
  visible: () => false,
  isClickable: () => false,
  isLocked: () => false,
  href: ({ flow }) => `/app/editor/${flow.id}/__create_template`,
};

export default createTemplateBehavior;
